import * as React from 'react';
import {Container as ContainerUI} from "@mui/material";
import {useSelector} from "react-redux";
import {styled} from "@mui/material/styles";

const StyledContainer = styled(ContainerUI)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
}));

export const Container = ({ component, children, sx, fullWidth }) => {

    return (
        <StyledContainer
            component={component || "div"}
            sx={{
                maxWidth: {
                    xs: fullWidth ? "100vw" : "100vw",
                    sm: fullWidth ? "100vw" : "90vw",
                    md: fullWidth ? "100vw" : "92vw",
                    lg: fullWidth ? "100vw" : "95vw",
                    xl: fullWidth ? "100vw" : "55vw",
                },
                minWidth: {
                    xs: "320px",
                    sm: "540px",
                    md: "720px",
                    lg: "960px",
                    xl: "1320px",
                },
                ...sx,
            }}
        >
            {children}
        </StyledContainer>
    );
};
